import React from "react";

const BS5_Certificate = () => {
  return (
    <div className="container mt-4">
      <h2>BS5_Certificate Component</h2>
      <p>This is the BS5_Certificate component for Bootstrap 5 tutorial.</p>
    </div>
  );
};

export default BS5_Certificate;
